import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Awads from "../../home/awads";

function Awardsrecognitions(props) {
    let className = "tekrevol_awards landing_awards"
    if (props.bg) {
        className = "tekrevol_awards gery tekrevol_gray_bg p-100"
    }
    return (
        <div className={className}>
            <Container className="h-100">
                <Row className="h-100">
                    <Awads content={true}/>
                </Row>
            </Container>
        </div>
    );
}

export default Awardsrecognitions;